import { render, staticRenderFns } from "./memCardModal.vue?vue&type=template&id=5d3fdf4a&scoped=true"
import script from "./memCardModal.vue?vue&type=script&lang=js"
export * from "./memCardModal.vue?vue&type=script&lang=js"
import style0 from "./memCardModal.vue?vue&type=style&index=0&id=5d3fdf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3fdf4a",
  null
  
)

export default component.exports